namespace TabAurous.OMS {
    export interface ColorQualityMappingRow {
        MappingId?: number;
        StoneColorId?: number;
        QualityId?: number;
        Code?: string;
        StoneColorCode?: string;
        QualityCode?: string;
    }

    export namespace ColorQualityMappingRow {
        export const idProperty = 'MappingId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'OMS.ColorQualityMapping';
        export const lookupKey = 'OMS.ColorQualityMapping';

        export function getLookup(): Q.Lookup<ColorQualityMappingRow> {
            return Q.getLookup<ColorQualityMappingRow>('OMS.ColorQualityMapping');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            MappingId = "MappingId",
            StoneColorId = "StoneColorId",
            QualityId = "QualityId",
            Code = "Code",
            StoneColorCode = "StoneColorCode",
            QualityCode = "QualityCode"
        }
    }
}
